module.exports = __webpack_public_path__ + "static/media/opening_animation.9761b243.mp4";